import React from 'react';
import styled from 'styled-components';

const CareSection = styled.section`
  padding: 6rem 2rem 4rem;
  background-color: var(--dark-gray);
`;

const SectionTitle = styled.h2`
  font-family: 'Blackwood Castle', serif;
  font-size: 3rem;
  color: var(--gold);
  text-align: center;
  margin-bottom: 3rem;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
`;

const CareContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 3rem;
  max-width: 1200px;
  margin: 0 auto;
`;

const CareCard = styled.div`
  width: 100%;
  max-width: 500px;
  background-color: var(--royal-blue);
  border: 2px solid var(--gold);
  border-radius: 5px;
  overflow: hidden;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.3);
  position: relative;
  &::before {
    content: '';
    position: absolute;
    top: -5px;
    left: -5px;
    right: -5px;
    bottom: -5px;
    border: 1px solid var(--gold);
    pointer-events: none;
    opacity: 0.5;
    z-index: 1;
    border-radius: 8px;
  }
`;

const CardHeader = styled.div`
  background-color: var(--gold);
  padding: 1.5rem;
  text-align: center;
`;

const CardTitle = styled.h3`
  font-family: 'Blackwood Castle', serif;
  font-size: 2rem;
  color: var(--royal-blue);
  margin: 0;
`;

const CardBody = styled.div`
  padding: 2rem;
`;

const CareText = styled.p`
  color: var(--white);
  font-size: 1.1rem;
  line-height: 1.6;
  margin-bottom: 1rem;
`;

const CareList = styled.ul`
  list-style: disc inside;
  color: var(--white);
  margin: 0;
  padding-left: 1rem;
`;

const CareListItem = styled.li`
  margin-bottom: 0.5rem;
`;

const Care = () => {
  return (
    <CareSection id="soins">
      <SectionTitle>Soins & Conseils</SectionTitle>
      <CareContainer>
        {/* After‐Tattoo Care */}
        <CareCard>
          <CardHeader>
            <CardTitle>Soins après un tatouage</CardTitle>
          </CardHeader>
          <CardBody>
            <CareText>
              Après un tatouage, il est essentiel de garder la zone propre et hydratée.  
              Utilisez une crème spécifique pour la cicatrisation et évitez  
              l'exposition directe au soleil pendant les premières semaines.
            </CareText>
            <CareList>
              <CareListItem>Lavez délicatement avec un savon doux.</CareListItem>
              <CareListItem>Appliquez une fine couche de crème cicatrisante.</CareListItem>
              <CareListItem>Évitez les piscines, saunas et bains chauds.</CareListItem>
            </CareList>
          </CardBody>
        </CareCard>

        {/* After‐Piercing Care */}
        <CareCard>
          <CardHeader>
            <CardTitle>Soins après un piercing</CardTitle>
          </CardHeader>
          <CardBody>
            <CareText>
              Les soins pour un piercing sont tout aussi importants.  
              Nettoyez régulièrement avec une solution saline et évitez  
              de manipuler le bijou avec des mains sales.
            </CareText>
            <CareList>
              <CareListItem>Nettoyez deux fois par jour avec une solution saline.</CareListItem>
              <CareListItem>Évitez de toucher ou de tourner le bijou inutilement.</CareListItem>
              <CareListItem>Surveillez les signes d'infection et consultez un professionnel si nécessaire.</CareListItem>
            </CareList>
          </CardBody>
        </CareCard>
      </CareContainer>
    </CareSection>
  );
};

export default Care;
